// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RxfG","option":"styles_option__1FDyu","selected":"styles_selected__1pR00"};